import { IContext } from '@/api';
import { DeleteRelocationLimit } from './DeleteRelocationLimit';
import { RelocationLimit } from './RelocationLimit';

export class DeleteRelocationLimitsContext
    implements IContext {

    public relocationLimits_Partial: DeleteRelocationLimit[];

    constructor(relocationLimits: RelocationLimit[]) {
        if (!relocationLimits) {
            this.relocationLimits_Partial = [];
        } else {
            this.relocationLimits_Partial = relocationLimits.map(
                x => new DeleteRelocationLimit(x.id)
            );
        }
    }
}
